import { IDocumentTypeOption } from 'Hooks/useDocumentUpload';
import { DocumentUploadProvider } from '../../../../Context/DocumentUploadContext';
import { DocumentUpload } from './DocumentUpload';
import { DeleteToast } from './DeleteToast';
import { DeleteConfirmationModal } from './DeleteConfirmationModal';
import { FilePreviewModal } from './FilePreviewModal';

export interface IDocumentUploadManager {
  availableDocumentTypes: IDocumentTypeOption[];
  onUploadComplete?: (documentTypes: any[]) => void;
}

export const DocumentUploadManager = ({
  availableDocumentTypes,
  onUploadComplete,
}: IDocumentUploadManager) => {
  return (
    <DocumentUploadProvider
      availableDocumentTypes={availableDocumentTypes}
      onUploadComplete={onUploadComplete}
    >
      <DocumentUpload />
      <DeleteToast />
      <DeleteConfirmationModal />
      <FilePreviewModal />
    </DocumentUploadProvider>
  );
};
